import { DocumentService } from '@fi-app/document/document.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

export const FiDocumentStatesResolveDocument = [
    DocumentService,
    FiStateService,
    '$transition$',
    FiDocumentStatesResolveDocumentResolveFunc,
];

export function FiDocumentStatesResolveDocumentResolveFunc(
    documentService: DocumentService,
    fiStateService: FiStateService,
    $transition$,
) {
    /*// if window.history.state.autoSaveId not null - back button was pressed
    // from versions list and we should restore autosaved content
    // https://chainformation.atlassian.net/browse/FI-2088
    var documentId = window.history.state && window.history.state.autoSaveId
        ? window.history.state.autoSaveId
        : $stateParams.Id;
    return DocumentService.GetDocument(documentId); todo*/

    return documentService.GetDocument(fiStateService.getParams($transition$).Id);
}
